import { createReducer, on } from '@ngrx/store';
import * as BiaActions from './bia.actions';
import { initialState } from './bia.state';

export const biaFeatureKey = 'BIA';

export const reducer = createReducer(
  initialState,
  on(BiaActions.loadAllBiasSuccess, (state, { bias }) => ({
    ...state,
    allBias: bias,
  })),
  on(BiaActions.loadBiasSuccess, (state, { bias }) => ({
    ...state,
    bias,
  })),
  on(BiaActions.loadBiasFailure, (state, action) => state),
  on(BiaActions.deleteBiaSuccess, (state, action) => {
    return {
      ...state,
      bias: state.bias.filter((bia) => bia.id !== action.id),
    };
  }),

  on(BiaActions.loadCallTreeSuccess, (state, action) => {
    return {
      ...state,
      callTrees: {
        ...state.callTrees,
        [action.id]: action.callTreeList,
      },
    };
  }),
  on(BiaActions.updateAppCallTreeSuccess, (state, action) => {
    const callTrees = state.callTrees[action.id];
    const cmpObj = action.appCallTreeList[0];
    const updatedState = {
      ...state,
      callTrees: {
        [action.id]: callTrees.map((ct) => {
          const matchingAct = action.appCallTreeList.find(
            (act) => act.callTree.id === ct.id
          );
          let finalCallTree = ct.finalCallTree;

          if (matchingAct) {
            let alreadyExists = false;
            finalCallTree = finalCallTree.map((fct) => {
              if (fct.id === matchingAct.id) {
                alreadyExists = true;
                return matchingAct;
              }
              return fct;
            });

            if (!alreadyExists) finalCallTree.push(matchingAct);

            return { ...ct, finalCallTree };
          }

          return ct;
        }),
      },
    };

    return updatedState;
  }),
  on(BiaActions.loadProcessesSuccess, (state, action) => {
    const updatedState = {
      ...state,
      processes: {
        ...state.processes,
        [action.id]: action.processes,
      },
    };
    return updatedState;
  }),
  on(BiaActions.addProcessSuccess, (state, action) => {
    const processes = state.processes[action.id];
    const updatedState = {
      ...state,
      processes: {
        ...state.processes,
        [action.id]: processes
          ? [...processes, action.process]
          : [action.process],
      },
    };
    return updatedState;
  }),
  on(BiaActions.updateProcessSuccess, (state, action) => {
    const processes = state.processes[action.id];
    const updatedState = {
      ...state,
      processes: {
        ...state.processes,
        [action.id]: processes.map((process) =>
          process.id === action.process.id ? action.process : process
        ),
      },
    };
    return updatedState;
  }),
  on(BiaActions.deleteProcessSuccess, (state, action) => {
    const processes = state.processes[action.id];
    const updatedState = {
      ...state,
      processes: {
        ...state.processes,
        [action.id]: processes.filter(
          (process) => process.id !== action.processId
        ),
      },
    };
    return updatedState;
  }),
  on(BiaActions.loadImpactSuccess, (state, action) => {
    const updatedState = {
      ...state,
      impacts: {
        ...state.impacts,
        [action.id]: action.impact,
      },
    };
    return updatedState;
  }),
  on(BiaActions.addOrUpdateImpactSuccess, (state, action) => {
    let itExists = false;
    const impacts = state.impacts[action.id].map((ai) => {
      if (ai.id === action.impact.id) {
        itExists = true;
        return action.impact;
      } else {
        return ai;
      }
    });
    if (!itExists) impacts.push(action.impact);

    return {
      ...state,
      impacts: {
        ...state.impacts,
        [action.id]: impacts,
      },
    };
  }),
  on(BiaActions.loadInDependenciesSuccess, (state, action) => {
    const updatedState = {
      ...state,
      inDependencies: {
        ...state.inDependencies,
        [action.id]: action.inDependencies,
      },
    };
    return updatedState;
  }),
  on(BiaActions.addInDependencySuccess, (state, action) => {
    const inDependencies = state.inDependencies[action.id];
    const updatedState = {
      ...state,
      inDependencies: {
        ...state.inDependencies,
        [action.id]: inDependencies
          ? [...inDependencies, action.inDependency]
          : [action.inDependency],
      },
    };
    return updatedState;
  }),
  on(BiaActions.updateInDependencySuccess, (state, action) => {
    const inDependencies = state.inDependencies[action.id];
    const updatedState = {
      ...state,
      inDependencies: {
        ...state.inDependencies,
        [action.id]: inDependencies.map((inDependency) =>
          inDependency.id === action.inDependency.id
            ? action.inDependency
            : inDependency
        ),
      },
    };
    return updatedState;
  }),
  on(BiaActions.deleteInDependencySuccess, (state, action) => {
    const inDependencies = state.inDependencies[action.id];
    const updatedState = {
      ...state,
      inDependencies: {
        ...state.inDependencies,
        [action.id]: inDependencies.filter(
          (inDependency) => inDependency.id !== action.inDependencyId
        ),
      },
    };
    return updatedState;
  }),
  on(BiaActions.loadExDependenciesSuccess, (state, action) => {
    const updatedState = {
      ...state,
      exDependencies: {
        ...state.exDependencies,
        [action.id]: action.exDependencies,
      },
    };
    return updatedState;
  }),
  on(BiaActions.addExDependencySuccess, (state, action) => {
    const exDependencies = state.exDependencies[action.id];
    const updatedState = {
      ...state,
      exDependencies: {
        ...state.exDependencies,
        [action.id]: exDependencies
          ? [...exDependencies, action.exDependency]
          : [action.exDependency],
      },
    };
    return updatedState;
  }),
  on(BiaActions.updateExDependencySuccess, (state, action) => {
    const exDependencies = state.exDependencies[action.id];
    const updatedState = {
      ...state,
      exDependencies: {
        ...state.exDependencies,
        [action.id]: exDependencies.map((exDependency) =>
          exDependency.id === action.exDependency.id
            ? action.exDependency
            : exDependency
        ),
      },
    };
    return updatedState;
  }),
  on(BiaActions.deleteExDependencySuccess, (state, action) => {
    const exDependencies = state.exDependencies[action.id];
    const updatedState = {
      ...state,
      exDependencies: {
        ...state.exDependencies,
        [action.id]: exDependencies.filter(
          (exDependency) => exDependency.id !== action.exDependencyId
        ),
      },
    };
    return updatedState;
  }),
  on(BiaActions.loadPeakTimeSuccess, (state, action) => {
    const updatedState = {
      ...state,
      peakTimes: {
        ...state.peakTimes,
        [action.id]: action.peakTimes,
      },
    };
    return updatedState;
  }),
  on(BiaActions.addPeakTimeSuccess, (state, action) => {
    const peakTimes = state.peakTimes[action.id];
    const updatedState = {
      ...state,
      peakTimes: {
        ...state.peakTimes,
        [action.id]: peakTimes
          ? [...peakTimes, action.peakTime]
          : [action.peakTime],
      },
    };
    return updatedState;
  }),
  on(BiaActions.deletePeakTimeSuccess, (state, action) => {
    const peakTimes = state.peakTimes[action.id];
    const updatedState = {
      ...state,
      peakTimes: {
        ...state.peakTimes,
        [action.id]: peakTimes.filter(
          (peakTime) => peakTime.id !== action.peakTimeId
        ),
      },
    };
    return updatedState;
  }),
  on(BiaActions.loadCriticalDeadlineSuccess, (state, action) => {
    const updatedState = {
      ...state,
      deadLines: {
        ...state.deadLines,
        [action.id]: action.cds,
      },
    };
    return updatedState;
  }),
  on(BiaActions.addCriticalDeadlineSuccess, (state, action) => {
    const deadLines = state.deadLines[action.id];
    const updatedState = {
      ...state,
      deadLines: {
        ...state.deadLines,
        [action.id]: deadLines ? [...deadLines, action.cd] : [action.cd],
      },
    };
    return updatedState;
  }),
  on(BiaActions.deleteCriticalDeadlineSuccess, (state, action) => {
    const deadLines = state.deadLines[action.id];
    const updatedState = {
      ...state,
      deadLines: {
        ...state.deadLines,
        [action.id]: deadLines.filter((cd) => cd.id !== action.cdId),
      },
    };
    return updatedState;
  }),
  on(BiaActions.loadAdInfoSuccess, (state, action) => {
    return {
      ...state,
      adInfo: {
        ...state.adInfo,
        [action.id]: action.adInfoes,
      },
    };
  }),
  on(BiaActions.addOrUpdateAdInfoSuccess, (state, action) => {
    let itExists = false;
    const adInfo = state.adInfo[action.id].map((ai) => {
      if (ai.id === action.adInfo.id) {
        itExists = true;
        return action.adInfo;
      } else {
        return ai;
      }
    });
    if (!itExists) adInfo.push(action.adInfo);

    return {
      ...state,
      adInfo: {
        ...state.adInfo,
        [action.id]: adInfo,
      },
    };
  }),
  on(BiaActions.loadVitalRecordSuccess, (state, action) => {
    return {
      ...state,
      vitalRecord: {
        ...state.vitalRecord,
        [action.id]: action.vitalRecords,
      },
    };
  }),
  on(BiaActions.addVitalRecordSuccess, (state, action) => {
    const vitalRecord = state.vitalRecord[action.id];
    const updatedState = {
      ...state,
      vitalRecord: {
        ...state.vitalRecord,
        [action.id]: vitalRecord
          ? [...vitalRecord, action.vitalRecord]
          : [action.vitalRecord],
      },
    };
    return updatedState;
  }),
  on(BiaActions.updateVitalRecordSuccess, (state, action) => {
    const vitalRecords = state.vitalRecord[action.id];
    const updatedState = {
      ...state,
      vitalRecord: {
        ...state.vitalRecord,
        [action.id]: vitalRecords.map((vr) =>
          vr.id === action.vitalRecord.id ? action.vitalRecord : vr
        ),
      },
    };
    return updatedState;
  }),
  on(BiaActions.deleteVitalRecordSuccess, (state, action) => {
    const vitalRecords = state.vitalRecord[action.id];
    const updatedState = {
      ...state,
      vitalRecord: {
        ...state.vitalRecord,
        [action.id]: vitalRecords.filter(
          (vt) => vt.id !== action.vitalRecordId
        ),
      },
    };
    return updatedState;
  }),

  on(BiaActions.loadHRSuccess, (state, action) => {
    return {
      ...state,
      hr: {
        ...state.hr,
        [action.id]: action.hrs,
      },
    };
  }),
  on(BiaActions.addHRSuccess, (state, action) => {
    const hr = state.hr[action.id];
    const updatedState = {
      ...state,
      hr: {
        ...state.hr,
        [action.id]: hr ? [...hr, action.hr] : [action.hr],
      },
    };
    return updatedState;
  }),
  on(BiaActions.updateHRSuccess, (state, action) => {
    const hrs = state.hr[action.id];
    const updatedState = {
      ...state,
      hr: {
        ...state.hr,
        [action.id]: hrs.map((vr) => (vr.id === action.hr.id ? action.hr : vr)),
      },
    };
    return updatedState;
  }),
  on(BiaActions.deleteHRSuccess, (state, action) => {
    const hrs = state.hr[action.id];
    const updatedState = {
      ...state,
      hr: {
        ...state.hr,
        [action.id]: hrs.filter((vt) => vt.id !== action.hr),
      },
    };
    return updatedState;
  }),

  on(BiaActions.loadResourceCallTreeSuccess, (state, action) => {
    return {
      ...state,
      resourceCallTree: {
        ...state.resourceCallTree,
        [action.id]: action.resourceCallTree,
      },
    };
  }),
  on(BiaActions.addResourceCallTreeSuccess, (state, action) => {
    const resourceCallTree = state.resourceCallTree[action.id];
    const updatedState = {
      ...state,
      resourceCallTree: {
        ...state.resourceCallTree,
        [action.id]: resourceCallTree
          ? [...resourceCallTree, action.resourceCallTree]
          : [action.resourceCallTree],
      },
    };
    return updatedState;
  }),
  on(BiaActions.updateResourceCallTreeSuccess, (state, action) => {
    const resourceCallTrees = state.resourceCallTree[action.id];
    const updatedState = {
      ...state,
      resourceCallTree: {
        ...state.resourceCallTree,
        [action.id]: resourceCallTrees.map((vr) =>
          vr.id === action.resourceCallTree.id ? action.resourceCallTree : vr
        ),
      },
    };
    return updatedState;
  }),
  on(BiaActions.deleteResourceCallTreeSuccess, (state, action) => {
    const resourceCallTrees = state.resourceCallTree[action.id];
    const updatedState = {
      ...state,
      resourceCallTree: {
        ...state.resourceCallTree,
        [action.id]: resourceCallTrees.filter(
          (vt) => vt.id !== action.resourceCallTree
        ),
      },
    };
    return updatedState;
  }),

  on(BiaActions.loadITInfraSuccess, (state, action) => {
    return {
      ...state,
      itInfraRquire: {
        ...state.itInfraRquire,
        [action.id]: action.iTInfras,
      },
    };
  }),
  on(BiaActions.addITInfraSuccess, (state, action) => {
    const itInfra = state.itInfraRquire[action.id];
    const updatedState = {
      ...state,
      itInfraRquire: {
        ...state.vitalRecord,
        [action.id]: itInfra ? [...itInfra, action.iTInfra] : [action.iTInfra],
      },
    };
    return updatedState;
  }),
  on(BiaActions.updateITInfraSuccess, (state, action) => {
    const itInfra = state.itInfraRquire[action.id];
    const updatedState = {
      ...state,
      itInfraRquire: {
        ...state.itInfraRquire,
        [action.id]: itInfra.map((vr) =>
          vr.id === action.iTInfra.id ? action.iTInfra : vr
        ),
      },
    };
    return updatedState;
  }),
  on(BiaActions.deleteITInfraSuccess, (state, action) => {
    const itInfraRequire = state.itInfraRquire[action.id];
    const updatedState = {
      ...state,
      itInfraRquire: {
        ...state.itInfraRquire,
        [action.id]: itInfraRequire.filter(
          (itInfraReq) => itInfraReq.id !== action.iTInfraId
        ),
      },
    };
    return updatedState;
  }),
  on(BiaActions.loadSplReqSuccess, (state, action) => {
    return {
      ...state,
      splReq: {
        ...state.splReq,
        [action.id]: action.splReqs,
      },
    };
  }),
  on(BiaActions.addSplReqSuccess, (state, action) => {
    const splR = state.splReq[action.id];
    const updatedState = {
      ...state,
      splReq: {
        ...state.splReq,
        [action.id]: splR ? [...splR, action.splReq] : [action.splReq],
      },
    };
    return updatedState;
  }),
  on(BiaActions.updateSplReqSuccess, (state, action) => {
    const splR = state.splReq[action.id];
    const updatedState = {
      ...state,
      splReq: {
        ...state.splReq,
        [action.id]: splR.map((sr) =>
          sr.id === action.splReq.id ? action.splReq : sr
        ),
      },
    };
    return updatedState;
  }),
  on(BiaActions.deleteSplReqSuccess, (state, action) => {
    const splReq = state.splReq[action.id];
    const updatedState = {
      ...state,
      splReq: {
        ...state.splReq,
        [action.id]: splReq.filter((sr) => sr.id !== action.splReqId),
      },
    };
    return updatedState;
  }),
  on(BiaActions.addAppNSoftSuccess, (state, action) => {
    const appnS = state.appNSoft[action.id];
    const updatedState = {
      ...state,
      appNSoft: {
        ...state.appNSoft,
        [action.id]: appnS ? [...appnS, action.appNSoft] : [action.appNSoft],
      },
    };
    return updatedState;
  }),
  on(BiaActions.loadAppNSoftSuccess, (state, action) => {
    return {
      ...state,
      appNSoft: {
        ...state.appNSoft,
        [action.id]: action.appNSofts,
      },
    };
  }),
  on(BiaActions.updateAppNSoftSuccess, (state, action) => {
    const apns = state.appNSoft[action.id];
    const updatedState = {
      ...state,
      appNSoft: {
        ...state.appNSoft,
        [action.id]: apns.map((aps) =>
          aps.id === action.appNSoft.id ? action.appNSoft : aps
        ),
      },
    };
    return updatedState;
  }),
  on(BiaActions.deleteAppNSoft, (state, action) => {
    const sr = state.appNSoft[action.id];
    const updatedState = {
      ...state,
      appNSoft: {
        ...state.appNSoft,
        [action.id]: sr.filter((srq) => srq.id != action.appNSoftId),
      },
    };
    return updatedState;
  }),
  on(BiaActions.addStaffReqSuccess, (state, action) => {
    const staffR = state.staffReq[action.id];
    const updatedState = {
      ...state,
      staffReq: {
        ...state.staffReq,
        [action.id]: staffR
          ? [...staffR, action.staffRequirement]
          : [action.staffRequirement],
      },
    };
    return updatedState;
  }),
  on(BiaActions.loadStaffReqSuccess, (state, action) => {
    return {
      ...state,
      staffReq: {
        ...state.staffReq,
        [action.id]: action.staffRequirements,
      },
    };
  }),
  on(BiaActions.updateStaffReqSuccess, (state, action) => {
    const sr = state.staffReq[action.id];
    const updatedState = {
      ...state,
      staffReq: {
        ...state.staffReq,
        [action.id]: sr.map((aps) =>
          aps.id === action.staffRequirement.id ? action.staffRequirement : aps
        ),
      },
    };
    return updatedState;
  }),
  on(BiaActions.deleteStaffReqSuccess, (state, action) => {
    const sr = state.staffReq[action.id];
    const updatedState = {
      ...state,
      staffReq: {
        ...state.staffReq,
        [action.id]: sr.filter((srq) => srq.id != action.staffReqId),
      },
    };
    return updatedState;
  }),
  on(BiaActions.loadSpofSuccess, (state, action) => {
    return {
      ...state,
      spof: {
        ...state.spof,
        [action.id]: action.spof,
      },
    };
  }),
  on(BiaActions.addOrUpdateSpofSuccess, (state, action) => {
    let updated = false;
    const spofs = state.spof[action.id]
      ? state.spof[action.id].map((spof) => {
          if (spof.id === action.spof.id) {
            updated = true;
            return action.spof;
          }
          return spof;
        })
      : [];
    if (!updated) {
      spofs.push(action.spof);
    }
    return {
      ...state,
      spof: {
        ...state.spof,
        [action.id]: spofs,
      },
    };
  }),
  on(BiaActions.loadBiaIntroSuccess, (state, action) => {
    return {
      ...state,
      biaIntro: {
        ...state.biaIntro,
        [action.biaId]: action.biaIntro,
      },
    };
  }),
  on(BiaActions.addOrUpdateBiaIntroSuccess, (state, action) => {
    const t = {
      ...state,
      biaIntro: {
        ...state.biaIntro,
        [action.biaIntro.bia.id]: [action.biaIntro],
      },
    };
    return t;
  })
);
